import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiService } from '../api.service';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';


@Component({
  selector: 'app-boats',
  templateUrl: './boats.component.html',
  styleUrls: ['./boats.component.css']
})
export class BoatsComponent implements OnInit {

  boatsVisible:boolean;
  boatsExpanded:boolean;

  // ATTENZIONE, tentativo 16/06/2023
  boatsHideArrived:boolean;
  boatsHideTrail:boolean;

  //---------------------------------------------------------------------------
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, public api:ApiService, public breakpointObserver: BreakpointObserver) { 

    this.matIconRegistry.addSvgIcon(
      "sailboat",
      // this.domSanitizer.bypassSecurityTrustResourceUrl("assets/flags/ad.svg")
      // this.domSanitizer.bypassSecurityTrustResourceUrl("assets/test-icon.svg")
      // this.domSanitizer.bypassSecurityTrustResourceUrl("assets/buoy_24px.svg")
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/sailboat_24px.svg")
      );                                                         
      this.matIconRegistry.addSvgIcon(
        "buoy",
        this.domSanitizer.bypassSecurityTrustResourceUrl("assets/circle_24_pixel_yellow.svg")
      );                                                         
  
  }
  //---------------------------------------------------------------------------
  ngOnInit() {


    this.breakpointObserver.observe(['(min-width: 960px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.boatsExpanded = true;
      }
      else {
        this.boatsExpanded = false;
      }
    })

    this.breakpointObserver.observe(['(min-width: 400px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
      }
      else {
        this.boatsExpanded = false;
      }
    })

    // Preparo la callback per ricezione dati
    this.api.boatsObservable.subscribe(data => {
      // console.log("boats::boatsObservable");
      
      // console.log(JSON.stringify(data));
    })
    this.api.boatsLeaderBoardsObservable.subscribe(data => {
      // console.log(JSON.stringify(data));
      // console.log(data);
      // console.log("boats::boatsLeaderBoardsObservable");
    })

    // TODO gestisci this.boatsVisible in base al dispositivo !
    this.boatsVisible = true;
    this.boatsExpanded = true;
  }
  //---------------------------------------------------------------------------
  boatsExpandToggle() {
    this.boatsExpanded = ! this.boatsExpanded;   
  }
//---------------------------------------------------------------------------
  
}